// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"settingsModal_inputContainer_G2cUX"};